import { render, staticRenderFns } from "./transceiver-udp-packet-chart.vue?vue&type=template&id=de118b68&"
import script from "./transceiver-udp-packet-chart.vue?vue&type=script&lang=ts&"
export * from "./transceiver-udp-packet-chart.vue?vue&type=script&lang=ts&"
import style0 from "./transceiver-udp-packet-chart.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports